module.exports = __webpack_public_path__ + "img/outside.39bb40cc.jpg";